<template>
    <div class="table-head head-fixed with-search">
        <div class="table-tr">
            <div class="table-th cell-length">{{ __('Patient') }}</div>
            <div v-if="showDaysTillEndOfSubscription" class="table-th cell-2x">{{ __('[shortcut] Prescription will expire') }}</div>
            <div class="table-th cell-2x">{{ __('Login') }}</div>
            <div class="table-th cell-progress">
                <button type="button" :class="{ active: showProgressCells === 'weight' }" class="button-weight" @click="selectProgressCells('weight')">{{ __('Weight') }}</button>
                <button type="button" :class="{ active: showProgressCells === 'waist' }" class="button-waist" @click="selectProgressCells('waist')">{{ __('Waist circumference') }}</button>
            </div>
            <div class="table-th">{{ __('Change') }}</div>
            <div class="table-th">{{ __('Goals') }}</div>
            <div class="table-th cell-call">{{ __('Call') }}</div>
        </div>
    </div>
</template>

<script>
import TableHeader from '@components/PatientsMatrix/TableHeader'
import TableHeaderProgressCellsMixin from '@components/PatientsMatrix/Mixins/TableHeaderProgressCellsMixin'

export default {
    extends: TableHeader,
    mixins: [TableHeaderProgressCellsMixin]
}
</script>
